import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from '../../nurturer-marketing/components/BrandMark';

function AuthPageBrand() {
  return (
    <Link to="/" className="brand">
      <BrandMark size={38} />
      <span className="name">NURTURER</span>
    </Link>
  );
}

export default AuthPageBrand;
